import { render, staticRenderFns } from "./DownloadFilesPopup.vue?vue&type=template&id=fa158264&scoped=true&"
import script from "./DownloadFilesPopup.vue?vue&type=script&lang=js&"
export * from "./DownloadFilesPopup.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFilesPopup.vue?vue&type=style&index=0&id=fa158264&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa158264",
  null
  
)

export default component.exports